import React from 'react';
import Welcome from './Welcome/Welcome';
import Goals from './Goals/Goals';
import CoursesTypes from './CoursesTypes';
import Categories from './Categories/Categories';

const AboutPage = () => (
  <>
    <Welcome />
    <CoursesTypes />
    <Goals />
    <Categories />
    
  </>
);

export default AboutPage;
